import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const autoHide = this.element.getAttribute("data-auto-hide");

    if (autoHide === "true") {
      setTimeout(() => {
        this.close();
      }, 4000);
    }
  }

  close() {
    this.element.classList.add("opacity-0");
    setTimeout(() => {
      this.element.remove();
    }, 1000);
  }
}
